export enum ECotationConditionPattern {
	patientPathologiesContains = "patient.pathologies.contains",
	seanceActesContains = "seance.actes.contains",
	seanceActesSome = "seance.actes.some",
	/** day.seances.actes.exceeds(act_xxxx, 5) */
	daySeancesActesExceeds = "day.seances.actes.exceeds"
}